import React from 'react';
import { Container } from '../Container';
import { ModalConfirm } from './ModalConfirm';
import { MODAL_SALIDA_LEYENDA, MODAL_SALIDA_TITULO } from '../../constants/modal';

export type ModalEnlaceExternoProps = {
  show: boolean;
  onClose: () => void;
  url?: string;
};

export const ModalEnlaceExterno = (props: ModalEnlaceExternoProps) => {
  function redirect() {
    props.onClose();
    window.open(props.url, '_blank');
  }

  return (
    <ModalConfirm
      show={props.show}
      onConfirm={redirect}
      onCancel={props.onClose}
      title={MODAL_SALIDA_TITULO}
      buttonOkLabel="Continuar"
      buttonCancelLabel="Cancelar"
      backgroundColor="secondary.2"
      color="secondary.1"
      buttonCancelVariant="transparent"
      buttonOkVariant="secondary"
    >
      <Container color="secondary.1" px="0">
        {/**Lector de pantalla: contenido de la leyenda
         *  preparado para este lector. Está visualmente
         *  oculto*/}
        <Container display="none" aria-hidden={false} aria-label={MODAL_SALIDA_LEYENDA.join(' ')} />

        <div aria-hidden="true">
          {MODAL_SALIDA_LEYENDA.map((line, index) => (
            <p key={index}>{line}</p>
          ))}
        </div>
      </Container>
    </ModalConfirm>
  );
};

ModalEnlaceExterno.displayName = 'ModalEnlaceExterno';
